<template>
  <div class="uploadinput" style="user-select: none" ref="uploadinputbox">
    <form id="uploadform" action method="post" runat="server">
      <input
        id="spriteJson"
        type="file"
        name="files[]"
        accept="application/json"
        v-on:change="uploadAllFils($event)"
      />
      <input
        id="spriteSvgFrame"
        type="file"
        name="files[]"
        accept=".svg, .SVG"
        v-on:change="uploadAllFils($event)"
      />
      <input
        id="spriteSvgLine"
        type="file"
        name="files[]"
        accept=".svg, .SVG"
        v-on:change="uploadAllFils($event)"
      />
      <input
        id="spriteSvgShap"
        type="file"
        name="files[]"
        accept=".svg, .SVG"
        v-on:change="uploadAllFils($event)"
      />

      <input
        id="imagePic"
        multiple="multiple"
        type="file"
        name="files[]"
        accept="image/jpeg, image/jpg, image/png"
        v-on:change="uploadImage($event)"
      />
      <input
        id="imagePicTwo"
        multiple="multiple"
        type="file"
        name="files[]"
        accept="image/jpeg, image/jpg, image/png, image/svg, image/SVG"
        v-on:change="uploadImage($event)"
      />
      <input
        id="imageFrame"
        multiple="multiple"
        type="file"
        name="files[]"
        accept="image/jpeg, image/jpg, image/png, image/svg, image/SVG"
        v-on:change="uploadImage($event)"
      />
      <input
        id="imageCover"
        type="file"
        name="files[]"
        accept="image/jpeg, image/jpg, image/png"
        v-on:change="uploadImage($event)"
      />
      <input
        id="imageWatermark"
        type="file"
        name="files[]"
        accept="image/jpeg, image/jpg, image/png"
        v-on:change="uploadImage($event)"
      />
      <input
        id="gif"
        type="file"
        name="files[]"
        accept="image/gif"
        v-on:change="uploadImage($event)"
      />
      <input
        id="videoMe"
        type="file"
        name="files[]"
        accept="video/mp4, video/NMP4"
        v-on:change="uploadVideo($event)"
      />
      <input
        id="audio"
        type="file"
        name="files[]"
        accept="audio/*"
        v-on:change="uploadAudio($event)"
      />
      <input
        id="music"
        type="file"
        name="files[]"
        accept="audio/*"
        v-on:change="uploadAudio($event)"
      />
      <!-- <input id="ppt" type="file" name="files[]" accept='application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.ms-powerpoint,application/ksdps, .dps' v-on:change="uploadPPT($event)"> -->
      <input
        id="ppt"
        type="file"
        name="files[]"
        accept=".pptx, .ppt, .dps"
        v-on:change="uploadPPT($event)"
      />
      <input
        id="videoAndImage"
        type="file"
        name="files[]"
        accept="image/jpeg, image/jpg, image/png, video/mp4, video/NMP4"
        v-on:change="uploadImageAndVideo($event)"
      />
    </form>
    <audio id="load-music" :src="audioUrl"></audio>
    <video id="load-video" :src="videoUrl"></video>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import domtoimage from "dom-to-image";
import imageType from "image-type";
import getPixels from "get-pixels-frame-info-update";
import UploadMixin from "@/components/mixins/UploadMixin";
//  画布
export default {
  name: "inputs",
  mixins: [UploadMixin],
  data() {
    return {
      audioUrl: "",
      videoUrl: "",
      file: {}, // 上传文件地址对象
      closeUpload: true,
      inputName: {
        videoName: "videoMe",
      },
    };
  },
  computed: {
    ...mapGetters([
      "TOOL",
      "UserMsg",
      "UserEquity",
      "UserLevel",
      "UserLevelType",
      "UserMsg",
    ]),
  },
  props: [],
  watch: {},
  mounted() {
    this.$bus.on("Modal_close_vue", (data) => {
      if (data.name == "uploadFilLoading") {
        this.changeUploadVideoFS();
      }
    });
    // 上传事件
    this.$bus.off("upload-outer-pic", this.uploadOuterPic);
    this.$bus.on("upload-outer-pic", this.uploadOuterPic);
  },
  beforeDestroy() {
    this.$bus.off("upload-outer-pic", this.uploadOuterPic);
  },
  methods: {
    fileToBuf(file) {
      return new Promise((resolve) => {
        try {
          let fr = new FileReader();
          let filename = file.name;
          fr.readAsArrayBuffer(file);
          fr.addEventListener(
            "loadend",
            (e) => {
              let buf = e.target.result;
              resolve(buf);
            },
            false
          );
        } catch (e) {
          resolve(null);
        }
      });
    },
    async uploadOuterPic(data) {
      if (await this.sizeExceeded([data.file])) {
        return;
      }
      let name = "";
      let uploadImageData = new FormData();
      uploadImageData.append(0, data.file);
      if (data.type === "image") {
        name = "imagePicTwo";
        let tFile = [];
        tFile.push(data.file);
        this.file = tFile;
        this.uploadFileFs({
          type: "image",
          name,
          uploadImageData,
          uploadMsg: false,
          file: tFile,
        });
      } else {
        name = "gif";
        this.file = null;
        this.file = data.file;
        this.uploadFileFs({
          type: "image",
          name,
          result: await this.fileToBuf(data.file),
          file: data.file,
        });
      }
    },
    async sizeExceeded(files) {
      let len = files.length;
      let filesSize = 0;
      for (let i = 0; i < len; i++) {
        filesSize += files[i].size;
      }
      let resp = await this.$http.get("/api/user/material/size");
      if (resp.data.code === 200) {
        let { size: currentSize, maxSize } = resp.data.data;
        if (currentSize + filesSize > maxSize) {
          // console.log("hahahahaha");
          this.$memberGuide({
            show: true,
            context: this,
            funcRight: {
              type: "materialCapacity",
              name: "素材空间",
            },
          });
          return true;
        }
      }
      return false;
    },
    async uploadAllFils(event) {
      let sizeExceeded = await this.sizeExceeded(event.target.files);
      if (sizeExceeded) {
        event.target.value = "";
        return;
      }

      const _this = this;
      this.file = event.target.files[0];
      let reader = new FileReader();

      switch (event.target.id) {
        case "spriteJson":
          break;
      }

      reader.readAsDataURL(this.file);

      reader.onload = function (e) {
        _this.file = event.target.files[0];
        _this.uploadFileFs({
          type: "",
          name: event.target.id,
          el: event.target,
        });
      };
    },
    async uploadImage(event) {
      let sizeExceeded = await this.sizeExceeded(event.target.files);
      if (sizeExceeded) {
        event.target.value = "";
        return;
      }
      // 素材上传图片
      const vm = this;
      let uploadImageData = new FormData(),
        errorData = {
          errorSize: 0,
          index: 0,
        };
      this.file = event.target.files;
      if (this.file.length > 10) {
        event.target.value = "";
        this.$bus.emit("FeaturesPop_vue", {
          name: "vipEquity",
          msg: "最多可同时上传10张图片，您选择的图片已超过10张。",
          btnClose: "知道了",
          promptType: 1, // 关闭按钮分类
          msgJudge: 1, // 判断文字放在哪个显示槽里
          type: 2,
          vipMsgNone: true,
        });
        return;
      }
      for (let i = 0; i < this.file.length; i++) {
        if (!this.file[i] || !this.file[i].name) return;

        if (event.target.id === "imagePic") {
          if (!/\.(?:jpg|JPG|jpeg|JPEG|png|PNG)$/.test(this.file[i].name)) {
            event.target.value = "";
            alert("该文件格式不支持，请导入jpg、jpeg、png格式的图片");
            return;
          }
        } else {
          if (
            !/\.(?:jpg|jpeg|JPEG|JPG|png|PNG|gif|GIF|svg|SVG)$/.test(
              this.file[i].name
            )
          ) {
            event.target.value = "";
            alert("该文件格式不支持，请导入jpg、jpeg、png格式的图片");
            return;
          }
        }

        let reader = new FileReader();
        reader.readAsArrayBuffer(this.file[i]);

        reader.onprogress = function (e) {
          //这个是定时触发的事件，文件较大的时候较明显
          var p = "已完成：" + Math.round((e.loaded / e.total) * 100) + "%";
          // reader.abort()
        };

        // reader.onabort = function(e) {
        //   console.log("TCL: reader.onabort -> e", e)
        // };

        // reader.onerror = function(e) {     //文件读取出错的时候触发
        //   console.log("TCL: reader.onerror -> e", e)
        // };

        let _this = this;

        reader.onload = async function (e) {
          errorData.index++;
          let u = new Uint8Array(reader.result);
          let accept = event.target.accept;
          let shouldBeGif = accept.indexOf("image/gif") > -1;
          let filenameArr = _this.file.length
            ? _this.file[i].name.split(".")
            : _this.file.name.split(".");
          let suffix = (
            "" + filenameArr[filenameArr.length - 1] || "空"
          ).toLowerCase();
          let t = imageType(u); // {ext: "png", mime: "image/png"}
          let judgeImgType = true;
          let ext = (t || {}).ext || "";
          ext = ext.toLowerCase();

          if (!shouldBeGif && (!t || ext == "gif")) {
            let imgName = ext == "gif" ? "静态" : suffix;
            if (_this.file.length == 1) {
              alert(`您上传的不是${imgName || ""}图，无法添加至项目。`);
              event.target.value = "";
              return;
            } else {
              judgeImgType = false;
              errorData.errorSize++;
            }
          }

          if (shouldBeGif) {
            if (suffix != ext) {
              alert(`您上传的不是gif图，无法添加至项目。`);
              event.target.value = "";
              return;
            }
          }

          switch (event.target.id) {
            case "imagePic": // 背景
            case "imagePicTwo": // 道具
            case "imageFrame": // 相框图片
              if (_this.file[i].size > 10 * 1024 * 1024) {
                errorData.errorSize++;
              } else if (judgeImgType) {
                uploadImageData.append(i, _this.file[i]);
              }

              if (errorData.index == event.target.files.length) {
                _this.uploadFileFs({
                  type: "image",
                  name: event.target.id,
                  uploadImageData,
                  uploadMsg: errorData.errorSize ? errorData.errorSize : false,
                });
              }
              break;
            case "imageCover": // 道具
            case "gif":
            case "imageWatermark": // 水印
              _this.file = event.target.files[0];
              _this.uploadFileFs({
                type: "image",
                name: event.target.id,
                result: reader.result,
              });
              return;
              break;
          }
        };
      }
    },
    async uploadAudio(event) {
      console.log(event);
      let sizeExceeded = await this.sizeExceeded(event.target.files);
      if (sizeExceeded) {
        event.target.value = "";
        return;
      }
      // 素材上传声音
      const vm = this;
      const file = event.target.files[0];
      this.file = event.target.files[0];
      if (!this.file.name) return;

      if (
        !/\.(?:mp3|m4a|wav|aac|amr)$/.test(this.file.name.toLocaleLowerCase())
      ) {
        event.target.value = "";
        alert("请上传mp3/m4a/wav/aac/amr文件");
        return;
      }

      if (this.file.size / 1024 / 1024 > 20) {
        event.target.value = "";
        alert("请选择小于20MB的文件");
        return;
      }

      var reader = new FileReader();

      reader.readAsDataURL(this.file);

      reader.onprogress = function (e) {
        //这个是定时触发的事件，文件较大的时候较明显
        var p = "已完成：" + Math.round((e.loaded / e.total) * 100) + "%";
      };

      reader.onabort = function (e) {};

      reader.onerror = function () {
        //文件读取出错的时候触发
      };

      let audio = document.getElementById("load-music");
      this.audioUrl =
        (window.createObjectURL && window.createObjectURL(this.file)) ||
        (window.URL && window.URL.createObjectURL(this.file)) ||
        (window.webkitURL && window.webkitURL.createObjectURL(this.file));

      audio.oncanplay = () => {
        this.file.duration = audio.duration;
      };

      let _this = this;
      reader.onload = function (e) {
        _this.uploadFileFs({ type: "audio", name: event.target.id });
      };

      if (/m4a$/i.test(file.type)) {
        const mediainfo = await new Promise((res) => window.MediaInfo(null, res));

        const getSize = () => file.size;
        const readChunk = async (chunkSize, offset) =>
          new Uint8Array(await file.slice(offset, offset + chunkSize).arrayBuffer());

        const info = await mediainfo.analyzeData(getSize, readChunk);
        // assumes we are only interested in audio duration
        const audio_track = info.media.track.find((track) => track[ '@type' ] === 'Audio');
        this.file.duration = audio_track.Duration;
      }
    },
    async uploadFileFs(data) {
      this.$bus.emit("upLoadingDown_vue", { type: 0, dataType: data.type });
      const vm = this;
      let _file = data.file || this.file;
      let urlapi = "/api/upload/file";
      let contenttype = "multipart/form-data; boundary=---12321";
      let formData = new FormData();
      let uploadingMsg = "";
      // console.log('_file', _file);
      formData.append("files[]", _file);
      if (!data.uploadMsg) {
        uploadingMsg = this.elMsg();
      }
      const nameMap = {
        imagePic: "背景，道具素材",
        imagePicTwo: "背景，道具素材",
        imageFrame: "背景，道具素材",
        gif: "GIF图",
      };

      switch (data.name) {
        case "imagePic": // 背景
        case "imagePicTwo": // 道具
        case "imageFrame": // 相框图片
          if (_file.length > 1) {
            this.$bus.emit("Modal_vue", {
              name: "uploadFilLoading",
              data: {
                Ntype: data.name,
              },
            });
            let timeoutid = setTimeout(() => {
              this.$bus.emit("uploadResourceLoading_vue", {
                // 上传完成的发出事件
                schedule: 0.4,
              });
              clearTimeout(timeoutid);
            }, 500);
          } else {
            if (_file[0].size > 10 * 1024 * 1024) {
              if (!data.uploadMsg) {
                uploadingMsg.close();
              }
              this.$message({
                showClose: true,
                message: `${nameMap[data.name]}上传需限制在10MB内。`,
                type: "error",
              });
              this.$bus.emit("upLoadingDown_vue", { type: 1 });
              document.getElementById(data.name).value = "";
              return;
            }
          }
          urlapi = "/api/upload/multiples";
          formData = "";
          formData = data.uploadImageData;
          break;
        case "gif":
          let breakout = false;
          let message = "";
          if (_file.size > 5 * 1024 * 1024) {
            message = `${nameMap[data.name]}上传需限制在5MB内。`;
            breakout = true;
          } else {
            await this.gifFrames(Buffer.from(data.result))
              .then((max) => {
                if (max.time) {
                  breakout = true;
                  message = `您上传的GIF文件过大，请按照如下提示择一调整：调整素材尺寸至${max.width}px * ${max.height}px;调整GIF动画时长至${max.time}s以内`;
                  alert(message);
                  message = "";
                }
              })
              .catch((err) => {
                breakout = true;
                message = err + "";
              });
          }

          if (breakout) {
            message &&
              this.$message({
                showClose: true,
                message: message,
                type: "error",
              });
            uploadingMsg.close();
            this.$bus.emit("upLoadingDown_vue", { type: 1 });
            document.getElementById(data.name).value = "";
            return;
          }
          break;
        case "imageCover": // 道具
          break;
        case "imageWatermark": // 水印
          if (_file && _file.size > 200 * 1024) {
            this.$message({
              showClose: true,
              message: "水印素材上传需限制在200KB内。",
              type: "error",
            });
            uploadingMsg.close();
            this.$bus.emit("upLoadingDown_vue", { type: 1 });
            document.getElementById(data.name).value = "";
            return;
          }
          break;
        case "videoAndImage":
          this.$bus.emit("upLoadingDown_vue", { type: 1 });
          document.getElementById(data.name).value = "";
          break;
      }
      switch (data.type) {
        case "music":
          urlapi = "/api/music/uploadMusic";
          break;
        case "ppt":
          urlapi = "/api/upload/ppt";
      }
      this.$bus.emit("uploadStart_vue", data);
      let config = {
        onUploadProgress: function (progressEvent) {
          let percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          vm.$bus.emit("upload.progress", {
            percent: percentCompleted,
            file: _file,
          });
        },
      };
      this.$http({
        url: urlapi,
        method: "post",
        data: formData,
        ...config,
      })
        .then((res) => {
          if (res.data.code === 200) {
            let uploadFileData = {
              // 上传完成的发出事件
              type: data.type,
              name: data.name,
              data: res.data.data,
              file: _file,
              fileName: data.fileName,
            };
            // console.log('uploadFileData', uploadFileData);

            switch (data.name) {
              case "imagePic": // 背景
              case "imagePicTwo": // 道具
              case "imageFrame": // 相框图片
                let messageIMG = "图片上传完成";
                if (data.uploadMsg) {
                  messageIMG =
                    "有" +
                    data.uploadMsg +
                    "张图片上传失败，请确保上传10M以内的PNG/JPEG/JPG图片且网络良好";
                }
                this.$message({
                  message: messageIMG,
                  type: "success",
                });
                if (_file.length > 1) {
                  this.$bus.emit("uploadResourceLoading_vue", {
                    // 上传完成的发出事件
                    schedule: 1,
                  });
                }
                break;
            }

            switch (data.type) {
              case "audio":
                this.$message("正在上传音乐，上传好后会通知您。");
                uploadFileData.duration = _file.duration;
                this.judgeVideo(
                  this.$handleAssetsUrl(res.data.data.filename),
                  uploadFileData,
                  res.data.data,
                  1
                );
                break;
              case "image":
                if (data.name === "gif") {
                  this.judgeGif(
                    this.$handleAssetsUrl(res.data.data.filename),
                    uploadFileData
                  );
                } else {
                  this.$bus.emit("upload_vue", uploadFileData);
                }
                break;
              default:
                this.$bus.emit("upload_vue", uploadFileData);
            }
            this.file = {}; // 上传文件
            if (!data.uploadMsg) {
              uploadingMsg.close();
            }
            this.changeUploadVideoFS();
          } else {
            this.$bus.emit("upLoadingDown_vue", { type: 1 });
            uploadingMsg.close();
            this.$message({
              showClose: true,
              message: "上传错误！请检查网络或文件格式",
              type: "error",
            });
          }
        })
        .catch((err) => {
          if (data.type === "ppt") {
            this.$bus.emit("upLoadingDown_vue", { type: 1, dataType: "ppt" });
          }
          this.elErrorMsg();
          uploadingMsg.close();
          console.log("打印错误", err, formData);
        });
    },
    async uploadVideo(event) {
      let sizeExceeded = await this.sizeExceeded(event.target.files);
      if (sizeExceeded) {
        event.target.value = "";
        return;
      }
      // 素材上传图片
      this.file = event.target.files[0];

      if (!this.file.name) return;

      if (!/\.(?:mp4|MP4)$/.test(this.file.name)) {
        event.target.value = "";
        alert("请上传mp4文件");
        return;
      }

      if (this.file.size / 1024 / 1024 > 30) {
        event.target.value = "";
        alert("请选择小于30MB的文件");
        return;
      }

      var reader = new FileReader();

      reader.readAsDataURL(this.file);

      reader.onprogress = function (e) {
        //这个是定时触发的事件，文件较大的时候较明显
        var p = "已完成：" + Math.round((e.loaded / e.total) * 100) + "%";
      };

      reader.onabort = function (e) {};

      reader.onerror = function () {
        //文件读取出错的时候触发
      };

      let audio = document.getElementById("load-video");
      this.videoUrl =
        (window.createObjectURL && window.createObjectURL(this.file)) ||
        (window.URL && window.URL.createObjectURL(this.file)) ||
        (window.webkitURL && window.webkitURL.createObjectURL(this.file));
      audio.oncanplay = () => {
        this.file.duration = audio.duration;
      };

      let _this = this;
      reader.onload = function (e) {
        let video = document.createElement("video");
        video.setAttribute("src", this.result);
        video.addEventListener("loadedmetadata", function (e) {
          if (video.duration < 60) {
            _this.uploadVideoFile({
              type: "video",
              name: event.target.id,
              width: video.videoWidth,
              height: video.videoHeight,
            });
          } else {
            event.target.value = "";
            alert("请选择时长小于60秒的视频");
          }
        });
        video.onerror = function (e) {
          alert("浏览器不支持该视频");
        };
      };
    },
    uploadVideoFile(data) {
      this.closeUpload = true;

      let name = window.uuid.generate() + this.file.name, //文件名
        size = this.file.size, //总大小
        succeed = 0;
      let shardSize = 6 * 1024 * 1024, //以2MB为一个分片
        shardCount = Math.ceil(size / shardSize); //总片数

      let arr = [];
      for (let i = 0; i < shardCount; i++) {
        arr.push(i);
      }
      let index = 0; //当前上传
      let start = 0; //分片开头
      let end = 0; //分片结尾
      let loaded = 0; //整体文件上传完成的动态进度
      let _this = this;
      let CancelToken = this.$http.CancelToken;
      let source = CancelToken.source();
      this.$bus.emit("Modal_vue", { name: "uploadFilLoading" });
      this.$bus.emit("uploadResourceLoading_vue", {
        // 上传完成的发出事件
        schedule: 0,
      });
      this.arrayFileBlockFS(
        name,
        data,
        index,
        size,
        start,
        end,
        shardSize,
        _this,
        shardCount,
        loaded,
        arr,
        source
      );
    },
    async uploadImageAndVideo(event) {
      let sizeExceeded = await this.sizeExceeded(event.target.files);
      if (sizeExceeded) {
        event.target.value = "";
        return;
      }
      this.file = event.target.files[0];
      if (!this.file.name) return;
      let type = "";

      if (/\.(?:mp4|MP4)$/.test(this.file.name)) {
        if (this.file.size > 30 * 1024 * 1024) {
          event.target.value = "";
          alert("请选择小于30m的视频资源");
          return;
        }
        type = "video";
      } else if (/\.(?:jpg|jpeg|JPG|png|PNG)$/.test(this.file.name)) {
        if (this.file.size > 10 * 1024 * 1024) {
          event.target.value = "";
          alert("请选择小于10m的图片资源");
          return;
        }
        type = "image";
      } else {
        event.target.value = "";
        alert("请上传视频或图片文件");
        return;
      }

      let reader = new FileReader();
      reader.readAsDataURL(this.file);
      reader.onprogress = function (e) {
        //这个是定时触发的事件，文件较大的时候较明显
        let p = "已完成：" + Math.round((e.loaded / e.total) * 100) + "%";
      };
      reader.onload = (e) => {
        if (type === "video") {
          let video = document.createElement("video");
          video.setAttribute("src", reader.result);
          video.addEventListener("loadedmetadata", () => {
            if (video.duration < 60) {
              this.file.duration = video.duration;
              this.uploadVideoFile({
                type: "video",
                name: event.target.id,
                width: video.videoWidth,
                height: video.videoHeight,
              });
            } else {
              event.target.value = "";
              alert("请选择时长小于60秒的视频");
            }
          });
        } else if (type === "image") {
          let mime = this.base64MimeType(reader.result);
          if (mime === "image/jpeg" || mime === "image/png") {
            this.uploadFileFs({
              type: "image",
              name: event.target.id,
            });
          } else {
            event.target.value = "";
            alert(`您上传的是${mime}文件，无法添加至项目。`);
          }
        }
      };
      reader.onabort = function (e) {};
      reader.onerror = function () {};
    },
    async uploadPPT(event) {
      // let sizeExceeded = await this.sizeExceeded(event.target.files);
      // if (sizeExceeded) {
      //   event.target.value = "";
      //   return;
      // }
      const _this = this;
      this.file = event.target.files[0];

      if (!(this.file || {}).name) return;

      if (!/\.(?:pptx?|dps)$/i.test(this.file.name)) {
        event.target.value = "";
        // alert('请上传ppt文件')
        this.$message({
          showClose: true,
          duration: 0,
          type: "error",
          message: "抱歉，该功能仅支持ppt、pptx及dps(WPS)文件格式！",
        });
        this.$bus.emit("pptAbort", "type", this.file);
        return;
      }

      let pptSize = this.UserEquity.pptSize;

      // 为什么注释这段：新版会员不限制这种大小
      // if (this.file.size / 1024 / 1024 > pptSize && pptSize < 200) {
      //   this.$memberGuide({
      //     show: true,
      //     funcRight: {
      //       type: "pptImport",
      //       name: "PPT导入-编辑器",
      //     },
      //   });
      //   event.target.value = "";
      //   this.$bus.emit("pptAbort", "size", this.file);
      //   return;
      // }

      if (this.file.size / 1024 / 1024 > 200) {
        event.target.value = "";
        this.$modal.show("MessageDialog", {
          contentHtml: true,
          content: `PPT文件导入的上限为200M，请压缩文件大小后再次导入。`,
          btns: [{ type: "custom", content: "我知道了" }],
          resultHandler: (type) => {},
        });
        this.$bus.emit("pptAbort", "size", this.file);
        return;
      }

      let reader = new FileReader();

      reader.readAsDataURL(this.file);

      reader.onload = function (e) {
        _this.file = event.target.files[0];
        _this.uploadFileFs({
          type: "ppt",
          name: event.target.id,
          el: event.target,
        });
      };
    },
    arrayFileBlockFS(
      name,
      data,
      index,
      size,
      start,
      end,
      shardSize,
      _this,
      shardCount,
      loaded,
      arr,
      source
    ) {
      start = end;
      end = start + shardSize;
      if (end > size) {
        end = size;
      }
      const chunk = _this.file.slice(start, end);
      const formData = new FormData();
      formData.append("files[]", chunk, name);
      // formData.append('filename', filename);

      _this
        .$http({
          url: `/api/upload/fileBlock?currentChunkSize=${shardSize}&index=${index}&chunkSize=${size}&totalChunks=${shardCount}`,
          // url: `webapi/upload/fileBlock?currentChunkSize=${perSize}&index=${index}&chunkSize=${filesize}&totalChunks=${chunkNumbers}`,
          method: "post",
          data: formData,
          // data: filename,
          headers: {
            "Content-Type": "multipart/form-data",
            // 'filename': filename
          },
          cancelToken: source.token,
          onUploadProgress: (e) => {
            // 属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
            // if (e.lengthComputable) {
            //     loaded = _loaded + e.loaded;
            //     _this.$emit('onProgress',{loaded,total:filesize,e});
            // }
          },
        })
        .then((results) => {
          // _loaded = (index+1)*2*1024*1024 ;
          _this.$bus.emit("uploadResourceLoading_vue", {
            // 上传完成的发出事件
            schedule: ((index + 1) / (shardCount + 1)).toFixed(2) - 0,
          });
          if (!index) {
            loaded = index + 1;
          } else {
            loaded = index;
          }
          if (index + 1 === arr.length && _this.closeUpload) {
            // 上传完成
            let filename = results.data.data.filename;
            _this.$http
              .post("/api/upload/mergeBlock", {
                filename: filename,
                chunkNumber: shardCount,
                width: data.width,
                height: data.height,
                videoType: 1,
              })
              .then((res) => {
                _this.judgeVideo(
                  _this.$handleAssetsUrl(res.data.data.filename),
                  data,
                  res.data.data
                );
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            if (_this.closeUpload) {
              index++;
              _this.arrayFileBlockFS(
                name,
                data,
                index,
                size,
                start,
                end,
                shardSize,
                _this,
                shardCount,
                loaded,
                arr,
                source
              );
            }
          }
        });
    },
    elMsg(data) {
      return this.$message({
        showClose: true,
        message: "正在上传文件",
        duration: 0,
      });
    },
    elErrorMsg(data) {
      this.$bus.emit("upLoadingDown_vue", { type: 1 });
      this.$message({
        showClose: true,
        message: "文件上传错误，请重试！",
        type: "error",
      });
    },
    captureImage(data, boxData, msgData) {
      // 给视频截图
      let video = document.createElement("video");
      let judgeVideo = true;
      video.setAttribute("src", data);
      video.crossOrigin = "";
      video.addEventListener(
        "canplaythrough",
        () => {
          if (judgeVideo) {
            video.currentTime = 2;
            judgeVideo = false;
            let timeoutid = setTimeout(() => {
              let canvas = document.createElement("canvas");
              canvas.width = video.videoWidth;
              canvas.height = video.videoHeight;
              canvas
                .getContext("2d")
                .drawImage(video, 0, 0, canvas.width, canvas.height);

              var img = document.createElement("img");
              img.src = canvas.toDataURL("image/png");

              canvas.toBlob((dataUrl) => {
                let formData = new FormData();
                formData.append("imageName", dataUrl);
                this.$http({
                  url: "/api/upload/file",
                  method: "post",
                  data: formData,
                  dataType: "json",
                  headers: {
                    "Content-Type": "multipart/form-data; boundary=---12321",
                  },
                }).then((res) => {
                  this.$bus.emit("uploadResourceLoading_vue", {
                    // 上传完成的发出事件
                    schedule: 1,
                  });
                  this.$bus.emit("upload_vue", {
                    // 上传完成的发出事件
                    type: boxData.type,
                    name: boxData.name,
                    data: msgData,
                    fileName: res.data.data.filename,
                    duration: this.file.duration,
                    file: this.file,
                  });
                  this.changeUploadVideoFS();
                });
              });
              clearTimeout(timeoutid);
            }, 2000);
          }
        },
        false
      );

      video.load();
    },
    judgeVideo(urlData, data, msgData, type) {
      // 判断视频,音乐是否存在
      let resourcesType = type || 0, // 0-视频，1-音乐
        resourcesDom = "video";

      if (!this.closeUpload && resourcesType == 0) return;
      switch (resourcesType) {
        case 1: // 音乐
          resourcesDom = "audio";
          break;
      }
      let video = document.createElement(resourcesDom);
      video.addEventListener("loadedmetadata", (e) => {
        switch (resourcesType) {
          case 0: // 视频
            this.captureImage(urlData, data, msgData);
            break;
          case 1: // 音乐
            this.$bus.emit("upload_vue", data);
            break;
        }
      });
      video.onerror = (e) => {
        // console.log('上传失败', e);
        let timeoutid = setTimeout(() => {
          this.judgeVideo(urlData, data, msgData, resourcesType);
          clearTimeout(timeoutid);
        }, 2000);
      };
      video.src = urlData;
    },
    judgeGif(urlData, data) {
      let img = new Image();
      img.src = urlData;
      img.onload = () => {
        img = null;
        this.$bus.emit("upload_vue", data);
      };
      img.onerror = (e) => {
        let timeoutid = setTimeout(() => {
          this.judgeGif(urlData, data);
          clearTimeout(timeoutid);
        }, 1000);
      };
    },
    gifFrames(url) {
      return new Promise((resolve, reject) => {
        getPixels(url, "image/gif", function (err, pixels, framesInfo) {
          if (err || pixels.shape.length < 4) {
            console.error(err || "gif格式问题");
            reject("gif格式错误");
          }
          let width = pixels.shape[1],
            height = pixels.shape[2],
            length = pixels.shape[0],
            maxF = Math.floor(12800 / width) * Math.floor(12800 / height),
            time = 0,
            times = [],
            maxT = 0,
            scale = 0;
          pixels = null;
          for (var i = 0; i < length; i++) {
            times[i] = framesInfo[i].delay + time;
            time = times[i];
          }
          if (maxF < length) {
            maxT = times[maxF - 1] / 100;
            scale = Math.sqrt(length / maxF);
            scale = calcScale(scale, width, height, length);
          }
          resolve({
            time: maxT,
            width: Math.floor(width / scale),
            height: Math.floor(height / scale),
          });
        });
      });

      function calcScale(s, w, h, l) {
        if (
          Math.floor(12800 / Math.floor(w / s)) *
            Math.floor(12800 / Math.floor(h / s)) >
          l
        ) {
          return calcScale(s / 1.001, w, h, l);
        } else {
          return s * 1.001;
        }
      }
    },
    changeUploadVideoFS() {
      document.getElementById("uploadform").reset();
      this.closeUpload = false;
    },
    base64MimeType(encoded) {
      let result = "";

      if (typeof encoded !== "string") {
        return result;
      }

      let mime = encoded.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);

      if (mime && mime.length) {
        result = mime[1];
      }

      return result;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.uploadinput {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Upload.vue